module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasError) ? _c('PageError') : _c('BreadcrumbsLayout', {
    attrs: {
      "bg": "#ededed",
      "breadcrumbs": _vm.breadcrumbsExtended
    }
  }, [_c('ExtButton', {
    staticStyle: {
      "width": "254px"
    },
    attrs: {
      "fill": _vm.visibleFilter,
      "text": _vm.visibleFilter ? 'Свернуть' : 'Гибкий поиск',
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.visibleFilter = !_vm.visibleFilter
      }
    }
  }), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "width": "254px",
      "z-index": "1",
      "position": "relative"
    }
  }, [_c('TransitionFade', [(_vm.visibleFilter) ? _c('FlexFilter', _vm._b({
    staticStyle: {
      "position": "absolute",
      "height": "auto"
    },
    on: {
      "submit": function($event) {
        _vm.visibleFilter = false
      }
    }
  }, 'FlexFilter', _vm.filterProps, false)) : _vm._e()], 1)], 1), _c('MonthCalendar', {
    attrs: {
      "items": _vm.items,
      "month": _vm.month,
      "year": _vm.year
    }
  }), _c('br'), _c('br'), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7343cbe8","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activities/calendar/component.vue
// module id = 41902cf5b7090698d804
// module chunks = 18